<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<header class="dl-topbar">
  <div class="dl-topbar__inner">

    <button
      #trigger
      type="button"
      class="dl-btn dl-btn--ghost dl-btn--icon dl-topbar__burger"
      [attr.aria-expanded]="isOpen"
      aria-controls="dl-drawer"
      aria-label="Open menu"
      (click)="toggle()">
      <mat-icon>menu</mat-icon>
    </button>

    <a routerLink="/" class="dl-topbar__brand">
      <img src="favicon.svg" alt="" class="dl-topbar__mark" aria-hidden="true">
      <span class="dl-topbar__name">Dental Hub</span>
    </a>

    <button
      type="button"
      class="dl-btn dl-btn--ghost dl-topbar__logout"
      (click)="logout()"
      matTooltip="Log out"
      aria-label="Log out">
      <mat-icon>logout</mat-icon>
      <span class="dl-topbar__logout-label">Log out</span>
    </button>
  </div>
</header>

<div class="dl-scrim" [class.is-open]="isOpen" (click)="close()" aria-hidden="true"></div>

<nav
  id="dl-drawer"
  class="dl-drawer"
  [class.is-open]="isOpen"
  role="dialog"
  aria-modal="true"
  aria-label="Main navigation"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="isOpen">

  <div class="dl-drawer__header">
    <span class="dl-drawer__brand">
      <img src="favicon.svg" alt="" class="dl-topbar__mark" aria-hidden="true">
      <span class="dl-topbar__name">Dental Hub</span>
    </span>
    <button
      type="button"
      class="dl-btn dl-btn--ghost dl-btn--icon"
      (click)="close()"
      aria-label="Close menu">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dl-drawer__links">
    <a
      *ngFor="let item of items; trackBy: trackByPath"
      [routerLink]="item.path"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: item.exact }"
      class="dl-drawer__link">
      <mat-icon>{{ item.icon }}</mat-icon>
      <span>{{ item.label }}</span>
    </a>
  </div>

  <div class="dl-drawer__footer">
    <button
      type="button"
      class="dl-btn dl-btn--danger-ghost dl-btn--block"
      (click)="logout()">
      <mat-icon>logout</mat-icon>
      Log out
    </button>
  </div>
</nav>
